import React from 'react';
import EventCategoryLayout from '../../components/EventCategoryLayout';

const WeddingEvents = () => {
  return <EventCategoryLayout categoryId="wedding" />;
};

export default WeddingEvents;
